
import './App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenuToggle = () => setMenuOpen((open) => !open);
  const handleNavClick = () => setMenuOpen(false);
  const [state, handleSubmit] = useForm("xeeonnwg");
  
  // Função para formatar o telefone
  const formatPhone = (value) => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 6) return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
  };
  
  const handlePhoneChange = (e) => {
    e.target.value = formatPhone(e.target.value);
  };
  return (
    <div className="csw-main-bg">
      {/* Navbar */}
      <nav className="csw-navbar">
        <div className="csw-logo">
          <img src={process.env.PUBLIC_URL + '/logo.png'} alt="CoreSwitch Logo" className="csw-logo-img" />
          <span className="csw-logo-text">CORESWITCH</span>
        </div>
        <button className="csw-hamburger" aria-label="Abrir menu" onClick={handleMenuToggle}>
          <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
        <ul className={`csw-nav-links${menuOpen ? ' csw-nav-open' : ''}`}>
          <li><a href="#home" onClick={handleNavClick}>Home</a></li>
          <li><a href="#sobre" onClick={handleNavClick}>Sobre Nós</a></li>
          <li><a href="#solucoes" onClick={handleNavClick}>Soluções</a></li>
          <li><a href="#contato" onClick={handleNavClick}>Contato</a></li>
          <li className="csw-nav-mobile-btn">
            <a href="https://wa.me/5521986459153?text=Ol%C3%A1%21%0AEu%20gostaria%20de%20conversar%20com%20um%20especialista." target="_blank" rel="noopener noreferrer" className="csw-btn csw-btn-primary" onClick={handleNavClick}>Fale Conosco</a>
          </li>
        </ul>
        <a href="https://wa.me/5521986459153?text=Ol%C3%A1%21%0AEu%20gostaria%20de%20conversar%20com%20um%20especialista." target="_blank" rel="noopener noreferrer" className="csw-btn csw-btn-primary csw-btn-desktop">Fale Conosco</a>
      </nav>

      {/* Menu Overlay */}
      {menuOpen && <div className="csw-menu-overlay" onClick={handleNavClick}></div>}

      {/* Hero Section */}
      <section className="csw-hero" id="home">
        <div className="csw-hero-content">
          <h1>Soluções de Inovação<br />e Conectividade Digital</h1>
          <p>Infraestrutura digital que impulsiona o futuro da tecnologia com inteligência e confiabilidade.</p>
          <div className="csw-hero-actions">
            <a href="#solucoes" className="csw-btn csw-btn-primary">Nossas Soluções</a>
          </div>
        </div>
      </section>

      {/* Sobre Section */}
      <section className="csw-sobre" id="sobre">
        <h2>Sobre a CoreSwitch</h2>
        <p className="csw-sobre-desc">Inovação tecnológica e confiança.<br />
        CoreSwitch é líder em soluções digitais, oferecendo infraestrutura robusta, inovação e conectividade.<br />
        Estamos comprometidos em conectar o mundo de forma inteligente e eficiente, criando o futuro da tecnologia.</p>
        <div className="csw-sobre-cards">
          <div className="csw-sobre-card"><span>+10</span><br />anos de experiência</div>
        </div>
      </section>

      {/* Soluções Section */}
      <section className="csw-solucoes" id="solucoes">
        <h2>Nossas Soluções Tecnológicas</h2>
        <p>Potencializamos sua empresa com tecnologia de ponta.</p>
        <div className="csw-solucoes-cards">
          <div className="csw-sol-card">
            <div className="csw-sol-icon"><i className="fas fa-desktop" aria-hidden="true"></i></div>
            <h3>Locação de Hardware</h3>
            <p>Notebooks e desktops completos, configurados conforme a necessidade da sua empresa, com teclado, mouse, monitor e nobreak inclusos. Também disponibilizamos smart TVs e impressoras conforme a demanda.</p>
          </div>
          <div className="csw-sol-card">
            <div className="csw-sol-icon"><i className="fas fa-network-wired" aria-hidden="true"></i></div>
            <h3>Serviço Técnico de Redes</h3>
            <p>Instalação, configuração e manutenção de redes para empresas: cabeamento estruturado, montagem de racks, instalação e configuração de switches, roteadores, pontos de acesso e CFTV. Garantia de conectividade estável e suporte especializado para seu ambiente corporativo.</p>
          </div>
          <div className="csw-sol-card">
            <div className="csw-sol-icon"><i className="fas fa-robot" aria-hidden="true"></i></div>
            <h3>Inteligência Artificial</h3>
            <p>IA para automação, análise de dados, inovação, chats inteligentes e soluções sob demanda para o seu negócio.</p>
          </div>
          <div className="csw-sol-card">
            <div className="csw-sol-icon"><i className="fas fa-shield-alt" aria-hidden="true"></i></div>
            <h3>Segurança Digital</h3>
            <p>Proteção avançada com as mais recentes tecnologias em segurança, incluindo serviço de pentest, cybersegurança e instalação de Fortigate para sua empresa.</p>
          </div>
          <div className="csw-sol-card">
            <div className="csw-sol-icon"><i className="fas fa-code" aria-hidden="true"></i></div>
            <h3>Desenvolvimento de Software Sob Demanda</h3>
            <p>Soluções personalizadas em software para atender às necessidades específicas do seu negócio. Sistemas web, integrações, automações e aplicativos desenvolvidos sob medida, com acompanhamento próximo e entrega ágil.</p>
          </div>
          <div className="csw-sol-card">
            <div className="csw-sol-icon"><i className="fas fa-globe" aria-hidden="true"></i></div>
            <h3>Soluções Digitais Essenciais</h3>
            <p>Registro de domínio, desenvolvimento de sites e configuração de e-mails corporativos profissionais para sua empresa ter presença digital completa e confiável.</p>
          </div>
            <div className="csw-sol-card">
              <div className="csw-sol-icon"><i className="fas fa-paint-brush" aria-hidden="true"></i></div>
              <h3>Design e Rebranding de Marca</h3>
              <p>Criação e renovação de identidade visual, logotipos, materiais gráficos e branding completo para fortalecer a presença e o posicionamento da sua marca no mercado.</p>
            </div>
            <div className="csw-sol-card">
              <div className="csw-sol-icon"><i className="fas fa-phone-alt" aria-hidden="true"></i></div>
              <h3>Sistema de Telefonia Analógica e por IP</h3>
              <p>Implantação, configuração e manutenção de sistemas de telefonia analógica e VoIP (telefonia por IP), integrando comunicação eficiente e econômica para empresas de todos os portes.</p>
            </div>
            <div className="csw-sol-card">
              <div className="csw-sol-icon"><i className="fas fa-bullhorn" aria-hidden="true"></i></div>
              <h3>Marketing Digital</h3>
              <p>Estratégias de marketing digital para aumentar a visibilidade da sua empresa, incluindo gestão de redes sociais, campanhas online, SEO e anúncios pagos.</p>
            </div>
            <div className="csw-sol-card">
              <div className="csw-sol-icon"><i className="fas fa-tools" aria-hidden="true"></i></div>
              <h3>Manutenção de Computadores</h3>
              <p>Serviço de manutenção preventiva e corretiva de computadores diretamente no local do cliente, garantindo agilidade, segurança e funcionamento contínuo dos equipamentos. Atendimentos emergenciais e por janela de horarios.</p>
            </div>
        </div>
      </section>

      {/* Contato Section */}
      <section className="csw-contato" id="contato">
        <div className="csw-contato-header">
          <h2>Entre em contato</h2>
          <p className="csw-contato-subtitle">Estamos prontos para transformar seu negócio com tecnologia de ponta</p>
        </div>
        
        {state.succeeded ? (
          <div className="csw-form-success">
            <p>✓ Mensagem enviada com sucesso! Entraremos em contato em breve.</p>
          </div>
        ) : (
          <div className="csw-form-container">
            <div className="csw-contact-info">
              <div className="csw-contact-info-item">
                <i className="fas fa-envelope"></i>
                <div>
                  <h4>Email</h4>
                  <p>comercial@coreswitch.com.br</p>
                </div>
              </div>
              <div className="csw-contact-info-item">
                <i className="fas fa-phone-alt"></i>
                <div>
                  <h4>Telefone</h4>
                  <p>(21) 98645-9153</p>
                </div>
              </div>
              <div className="csw-contact-info-item">
                <i className="fas fa-clock"></i>
                <div>
                  <h4>Horário</h4>
                  <p>Seg - Sex: 8h às 17h</p>
                </div>
              </div>
            </div>
            
            <div className="csw-form-logo-center">
              <img src={process.env.PUBLIC_URL + '/cslogo_cut.png'} alt="CoreSwitch Logo" />
            </div>
            <form onSubmit={handleSubmit} className="csw-contact-form">
              <div className="csw-form-row">
                <div className="csw-form-group">
                  <input
                    id="nome"
                    type="text"
                    name="nome"
                    required
                    placeholder="Nome completo"
                  />
                  <ValidationError 
                    prefix="Nome" 
                    field="nome"
                    errors={state.errors}
                  />
                </div>

                <div className="csw-form-group">
                  <input
                    id="celular"
                    type="tel"
                    name="celular"
                    required
                    placeholder="(XX) XXXXX-XXXX"
                    maxLength="15"
                    onChange={handlePhoneChange}
                  />
                  <ValidationError 
                    prefix="Celular" 
                    field="celular"
                    errors={state.errors}
                  />
                </div>
              </div>

              <div className="csw-form-group">
                <input
                  id="email"
                  type="email"
                  name="email"
                  required
                  placeholder="seu-email@coreswitch.com.br"
                />
                <ValidationError 
                  prefix="Email" 
                  field="email"
                  errors={state.errors}
                />
              </div>

              <div className="csw-form-group">
                <textarea
                  id="mensagem"
                  name="mensagem"
                  required
                  maxLength="1000"
                  placeholder="Como podemos ajudar sua empresa?"
                  rows="5"
                />
                <ValidationError 
                  prefix="Mensagem" 
                  field="mensagem"
                  errors={state.errors}
                />
              </div>

              <button 
                type="submit" 
                disabled={state.submitting}
                className="csw-submit-btn"
              >
                {state.submitting ? 'ENVIANDO...' : 'ENVIAR'}
              </button>
            </form>
          </div>
        )}
      </section>

      {/* Footer */}
      <footer className="csw-footer">
        <div className="csw-footer-copyright">
          Todos os direitos reservados CORESWITCH © 2025
        </div>
      </footer>
    </div>
  );
}

export default App;
